export const EMPTY_ANALYTICS_BANNER_INTERACTION = Symbol('emptyAnalyticsBannerInteraction');

/**
 * What the banner analytics actually receive: the prop defaults to null and the
 * carousels pass the empty-interaction symbol, both of which isValid rejects.
 */
export type BannerInteractionInput = PromotionSchema | typeof EMPTY_ANALYTICS_BANNER_INTERACTION | null | undefined;

export const AnalyticsBannerInteraction = {
  create ({
    promotionName,
    promotionPageHref,
    promotionCompanyNo,
    promotionComponentId,
    promotionIndex,
    promotionBannerIndex,
  }: PromotionSchema): PromotionSchema {
    // full_carousel: 'teljes_szelessegu_carousel',
    return {
      promotionName,
      promotionPageHref,
      promotionCompanyNo,
      promotionComponentId,
      promotionIndex,
      promotionBannerIndex,
    };
  },
  // Accepts unknown because callers pass the raw prop, which may be null or the
  // empty-interaction symbol; the try/catch was already carrying that weight.
  isValid (o: unknown): o is PromotionSchema {
    if (typeof o !== 'object' || o === null) {
      return false;
    }
    const {
      promotionName,
      promotionPageHref,
      promotionComponentId,
      promotionIndex,
      promotionBannerIndex,
      promotionCompanyNo,
    }: Partial<Record<keyof PromotionSchema, unknown>> = o;
    return ((typeof promotionName === 'string' || promotionName === null) &&
      (typeof promotionPageHref === 'string') &&
      (typeof promotionCompanyNo === 'string' || promotionCompanyNo === null) &&
      (typeof promotionComponentId === 'string') &&
      (typeof promotionIndex === 'number') &&
      (typeof promotionBannerIndex === 'number' || typeof promotionBannerIndex === 'string')
    );
  },
  format ({
    promotionName,
    promotionPageHref,
    promotionCompanyNo,
    promotionComponentId,
    promotionIndex,
    promotionBannerIndex,
  }: PromotionSchema) {
    return {
      promotion_id: (
        `[${
          escapeSpecialChars(promotionPageHref)
        }][${
          escapeSpecialChars(promotionCompanyNo || 'default')
        }][${
          escapeSpecialChars(promotionComponentId)
        }][${
          escapeSpecialChars(promotionIndex)
        }][${
          escapeSpecialChars(promotionBannerIndex)
        }]`
      ),
      promotion_name: promotionName || null,
    };
  },
};

function escapeSpecialChars (str: string | number) {
  return `${str}`.replace(/(\[|\])/g, '\\$1');
}

export interface PromotionSchema {
  promotionName: string | null;
  promotionPageHref: string;
  promotionCompanyNo: string | null;
  promotionComponentId: string;
  promotionIndex: number;
  promotionBannerIndex: number | string;
}
